<template>
    <div class="userSignupGroupWrapper">
        <div class="titleWrapper">
            <div class="titleItem">{{ group.name }}</div>
            <div class="titleItem">YOKUMIRU利用アカウント発行</div>
        </div>
        <template v-if="user === null">
            <div class="card">
                <div class="card-body">
                    <form @submit.stop.prevent="submit">
                        <div class="form-row">
                            <div class="col">
                                <label
                                    for="email"
                                    class="col-form-label is-required-ja">
                                    メールアドレス
                                </label>
                                <input
                                    v-model="email"
                                    type="email"
                                    name="email"
                                    id="email"
                                    class="form-control"
                                    :class="{ 'is-invalid' : errors.email || errors.message }"
                                    placeholder="example@yokumiru.jp"
                                    required>
                                <div v-if="errors.email" class="invalid-feedback d-block">
                                    {{ errors.email[0] }}
                                </div>
                                <div v-else-if="errors.message" class="invalid-feedback d-block">
                                    {{ errors.message[0] }}
                                </div>
                            </div>
                        </div>
                        <div
                            v-if="errors.email && errors.email[0] === 'メールアドレスは既に登録されています。'"
                            class="form-row">
                            <div class="col">
                                <div class="registerProvisionalEmailDuplicated small mt-1">
                                    パスワードをお忘れの場合は、<a href="/password/reset">こちら</a>からパスワードの再発行ができます。
                                </div>
                            </div>
                        </div>

                        <div class="d-flex justify-content-center text-center mt-3">
                            <p class="registerProvisionalTerms">
                                <a href="https://yokumiru.jp/terms" target="_blank">利用規約</a>・<a href="https://yokumiru.jp/privacy-policy" target="_blank">プライバシーポリシー</a>をご確認のうえ、<br>同意してからボタンを押してください。
                            </p>
                        </div>

                        <div class="text-center">
                            <div class="loginButtonWrapper">
                                <button
                                    type="submit"
                                    class="btn btn-yokumiru-user loginButton mb-0"
                                    style="line-height:0"
                                    :disabled="inProgress">
                                    {{ inProgress ? '処理中です' : 'アカウントを発行' }}
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </template>
        <template v-else>
            <div class="card">
                <div class="card-body">
                    <div class="text-center mt-2 mb-3">「{{ group.name }}」の利用アカウント発行を行います。<br>以下のボタンから進んでください。</div>
                    <div class="text-center">
                        <div class="loginButtonWrapper">
                            <b-button
                                variant="yokumiru-user"
                                :disabled="inProgress"
                                @click="submitAsUser">
                                {{ inProgress ? '処理中です' : 'アカウントを発行' }}
                            </b-button>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>f

<script>
import YokumiruHelper from '../../YokumiruHelper'
import constants from '../../constants'

export default {
    props: {
        // appQuery: {
        //     type: String,
        //     default: '',
        // },
        formrunUid: {
            type: String,
            required: true,
        },
        group: {
            type: Object,
            default: null,
        },
        user: {
            type: Object,
            default: null,
        },
    },

    data: function() {
        return {
            helper: YokumiruHelper,
            email: null,
            inProgress: false,
            errors: {},
        }
    },

    computed: {
        submitParams: function () {
            return {
                email: this.email,
                utm_content: `${this.group.name} 利用アカウント発行ページ`,
                source: '未設定',
                formrun_uid: this.formrunUid,
                group_token: this.$route.query.group_token ? this.$route.query.group_token : null,
            }
        },
    },

    methods: {
        /**
         * 利用アカウント発行（新規）
         */
        submit: async function () {
            if (this.inProgress) return
            this.inProgress = true

            await axios.post(constants.user.register_provisional.endpoint.base, this.submitParams)
                .then(() => {
                    let query = ''
                    query += this.$route.query.group_token ? `&group_token=${this.$route.query.group_token}` : ''
                    window.location.href = `/register/provisional/complete${query.replace(/^&(.+)$/u, '?$1')}`
                })
                .catch(({response}) => {
                    if (response &&
                        response.hasOwnProperty('data') &&
                        response.data.hasOwnProperty('errors')) {
                        bus.$emit('alert-danger')
                        this.errors = response.data.errors
                    }
                    else {
                        bus.$emit('alert-danger', 'システムエラーが発生しました。')
                    }
                    // 登録が正常完了した場合のリダイレクト中にボタンを再押下させないために catch 内でのみ解除
                    this.inProgress = false
                })
        },

        /**
         * 利用アカウント発行（既存会員）
         */
        submitAsUser: async function () {
            if (this.inProgress) return
            this.inProgress = true

            await axios.post(`${constants.user.groups.endpoint.base}/register`, this.submitParams)
                .then(() => {
                    let query = ''
                    query += this.$route.query.group_token ? `&group_token=${this.$route.query.group_token}` : ''
                    window.location.href = `/register/provisional/complete${query.replace(/^&(.+)$/u, '?$1')}`
                })
                .catch(({response}) => {
                    if (response &&
                        response.hasOwnProperty('data') &&
                        response.data.hasOwnProperty('errors')) {
                        if (response.data.errors.hasOwnProperty('message')) {
                            bus.$emit('alert-danger', response.data.errors.message[0])
                            this.errors = response.data.errors
                        }
                        else {
                            bus.$emit('alert-danger')
                            this.errors = response.data.errors
                        }
                    }
                    else {
                        bus.$emit('alert-danger', 'システムエラーが発生しました。')
                    }
                    // 登録が正常完了した場合のリダイレクト中にボタンを再押下させないために catch 内でのみ解除
                    this.inProgress = false
                })
        },
    },
}
</script>

<style lang="scss" scoped>
.titleWrapper {
    margin-bottom: 16px;
    text-align: center;

    .titleItem {
        color: #2A2E31;
        font-size: 23px;
        font-weight: bold;
        line-height: 1.35;
    }
}

.userSignupGroupWrapper {
    max-width: 640px;
    margin: 0 auto 100px auto;

    @media screen and (max-width:640px) {
        max-width: 90%;
        margin: 0 auto 60px auto;
    }

    .registerProvisionalTerms {
        margin-top: 8px;
        margin-bottom: 15px;

        a {
            text-decoration: underline;

            &:hover {
                text-decoration: none;
            }
        }
    }

    .registerProvisionalButtonWrapper {
        margin-top: 15px;
    }

    .registerProvisionalEmailDuplicated {
        background: #ffe69a8f;
        padding: 8px 10px;
        border-radius: 4px;

        a {
            text-decoration: underline;
        }
    }
}

.loginFormLabel {
    color: #4d4a4a;
    font-size: 14px;
    margin-bottom: 3px;
}

.loginFormTextLink {
    font-size: 14px;
    text-decoration: underline;
}

.loginFormTextLink:hover {
    text-decoration: none;
}

.loginFormTextLinkSmall {
    font-size: 13px;
}

/**
 * loginButton
 */
.loginButtonWrapper {
    max-width: 320px;
    margin: 8px auto;
}

.loginButton {
    display: block;
    width: 100%;
    height: 40px;
    line-height: 40px;
    text-decoration: none;
    border-radius: 4px;
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out
}

.loginButton:hover {
    text-decoration: none;
}
</style>
